import React, { useState, useRef } from 'react';

import { useEffect } from 'react';
import 'react-image-gallery/styles/css/image-gallery.css';
import ImageGallery from 'react-image-gallery';
// import { Dialog, Transition } from '@headlessui/react';
import {
  spressoColors,
  spressoSliders,
  spressoVariants,
  spressoMileage,
  spressoData,
} from '../../constants/spressoData';
import SpressoBanner from '../../assets/banners/Website_Maruti_Suzuki_Dream_Series_Saboo_RKS_Motor_June_Offers.webp';
import Header from '../../components/header/Header';
import { Helmet } from 'react-helmet';
import { toast } from 'react-toastify';
import axios from 'axios';
// import { CgSpinner } from 'react-icons/cg';
import { CarEnquiryDown } from '../Forms/CarEnquiryDown';
import { Link } from 'react-router-dom';
import PriceTable from '../reusable/pricetable';
import CarDetails from '../reusable/cardslider';

function Spresso() {
  const carEnquiryRef = useRef(null);
  const scrollToCarEnquiry = () => {
    if (carEnquiryRef.current) {
      carEnquiryRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };
  return (
    <>
      <Helmet>
        <title>
          Maruti Suzuki S-Presso 2025 Summer Discounts – Where Style Meets
          Performance at RKS Motor! Exclusive may 2025 Offers on Maruti Suzuki
          S-Presso – Limited-Time Summer Deals!
        </title>
        <meta
          name='title'
          content=' Maruti Suzuki S-Presso 2025 Summer Discounts – Where Style Meets Performance at RKS Motor! Exclusive may 2025 Offers on Maruti Suzuki S-Presso – Limited-Time Summer Deals!'
        />
        <meta
          name='description'
          content="Celebrate may 2025 Summer Discounts on Maruti Suzuki S-Presso at Saboo RKS! Get the stylish mini-SUV, Maruti Suzuki S-Presso, designed for city adventures, with exclusive may summer offers and limited-time savings. Don't miss out—book now and drive home your dream car this season!"
        />
        <meta
          name='keywords'
          content='Maruti S-Presso 2025 Discounts, may 2025 Summer Offers on Maruti S-Presso, Maruti Suzuki S-Presso may Deals, 2025 Summer Car Discounts, Maruti S-Presso Compact SUV Summer Offers, Maruti Suzuki Arena 2025 Summer Specials, Exclusive may 2025 S-Presso Deals, S-Presso 2025 Summer Savings, Maruti S-Presso Limited-Time Summer Offers, Maruti Suzuki S-Presso may Festive Deals, 2025 Summer Car Sale, Maruti S-Presso may Specials, S-Presso Summer Discounts 2025.'
        />
        <meta name='author' content='Broaddcast' />
        <meta property='og:type' content='website' />
        <meta
          property='og:url'
          content='https://www.saboomaruti.in/maruti-s-presso-on-road-price-in-hyderabad'
        />
        <meta
          property='og:title'
          content=' Maruti Suzuki S-Presso 2025 Summer Discounts – Where Style Meets Performance at RKS Motor! Exclusive may 2025 Offers on Maruti Suzuki S-Presso – Limited-Time Summer Deals'
        />
        <meta
          property='og:description'
          content=":Celebrate may 2025 Summer Discounts on Maruti Suzuki S-Presso at Saboo RKS! Get the stylish mini-SUV, Maruti Suzuki S-Presso, designed for city adventures, with exclusive may summer offers and limited-time savings. Don't miss out—book now and drive home your dream car this season!"
        />
        <meta property='og:image' content='img/og-tags/s-presso.webp' />
        <meta property='twitter:card' content='summary_large_image' />
        <meta property='twitter:url' content='https://x.com/saboorksmaruti' />
        <meta
          property='twitter:title'
          content=' Maruti Suzuki S-Presso 2025 Summer Discounts – Where Style Meets Performance at RKS Motor! Exclusive may 2025 Offers on Maruti Suzuki S-Presso – Limited-Time Summer Deals! '
        />
        <meta
          property='twitter:description'
          content=":Celebrate may 2025 Summer Discounts on Maruti Suzuki S-Presso at Saboo RKS! Get the stylish mini-SUV, Maruti Suzuki S-Presso, designed for city adventures, with exclusive may summer offers and limited-time savings. Don't miss out—book now and drive home your dream car this season!"
        />
        <meta property='twitter:image' content='img/og-tags/s-presso.webp' />
      </Helmet>
      <Header />
      <img src={SpressoBanner} className='w-full max-w-full lg:mt-16' alt='1' />
      <div className='container grid grid-cols-1 gap-5 px-5 mx-auto my-8 sm:grid-cols-2 sm:px-0'>
        <div>
          <ImageGallery
            lazyLoad={true}
            autoPlay={true}
            thumbnailPosition='left'
            showPlayButton={false}
            items={spressoSliders}
          />
        </div>
        <div>
          <CarDetails {...spressoData} />
        </div>
      </div>
      <div className='container mx-auto'>
        <div className='mx-5'>
          {/* Car Enquiry and Colors */}
          <div className='flex flex-col lg:flex-row lg:space-x-4'>
            <div className='mb-4 lg:w-1/2 lg:mb-0' ref={carEnquiryRef}>
              <CarEnquiryDown title='S-PRESSO' carName='S-PRESSO' />
            </div>
            <div className='lg:w-1/2'>
              <Colors />
            </div>
          </div>

          {/* Table and PriceTable */}
          <div className='mt-8'>
            <div className='mt-8'>
              <PriceTable
                sections={[
                  {
                    headers: ['Variants', 'Transmission', 'Price'],
                    columns: ['title', 'transmission', 'price'],
                    rows: spressoVariants,
                  },
                  {
                    headers: ['FUELTYPE', 'Transmission', 'Mileage'],
                    columns: ['fueltype', 'transmission', 'mileage'],
                    rows: spressoMileage,
                  },
                ]}
                disclaimer=' The prices and
          mileage information provided in the table above are indicative and
          subject to change. The actual prices and mileage of Maruti Suzuki
          vehicles may vary based on factors such as location, dealer, variant,
          and other applicable conditions. For the most accurate and up-to-date
          information, please contact your nearest Saboo RKS Motor Maruti Suzuki
          dealership.'
              />
            </div>
          </div>
        </div>
        <div>
          {' '}
          <img
            src='https://images-saboomaruti-in.s3.ap-south-1.amazonaws.com/Arena/cars/new-spresso/new-spresso-brochure.webp'
            alt='brochure'
            className='w-full'
          />
        </div>
      </div>
    </>
  );
}

const Colors = () => {
  const [current, setCurrent] = useState(1);
  return (
    <div className='container flex flex-col items-center py-8 mx-auto mt-16 bg-gray-100 rounded-3xl'>
      {spressoColors.map((item) => (
        <img
          key={item.id}
          src={item.img}
          className={item.id === current ? 'mx-auto sm:h-80' : 'hidden'}
          alt={item.id}
        />
      ))}
      <div className='flex items-center justify-center space-x-3 space-y-1 sm:space-y-0'>
        <p
          className={
            current === 1
              ? 'h-5 rounded-full w-5 bg-[#004eba] animate-bounce'
              : 'h-5 rounded-full w-5 bg-[#004eba]'
          }
          onClick={(e) => setCurrent(1)}
        ></p>
        <p
          className={
            current === 2
              ? 'h-5 rounded-full w-5 bg-[#909090] animate-bounce'
              : 'h-5 rounded-full w-5 bg-[#909090]'
          }
          onClick={(e) => setCurrent(2)}
        ></p>
        <p
          className={
            current === 3
              ? 'h-5 rounded-full w-5 bg-[#ec6904] animate-bounce'
              : 'h-5 rounded-full w-5 bg-[#ec6904]'
          }
          onClick={(e) => setCurrent(3)}
        ></p>
        <p
          className={
            current === 4
              ? 'h-5 rounded-full w-5 bg-[#AB0F13] animate-bounce'
              : 'h-5 rounded-full w-5 bg-[#AB0F13]'
          }
          onClick={(e) => setCurrent(4)}
        ></p>
        <p
          className={
            current === 5
              ? 'h-5 rounded-full w-5 bg-[#D2CFD0] animate-bounce'
              : 'h-5 rounded-full w-5 bg-[#D2CFD0]'
          }
          onClick={(e) => setCurrent(5)}
        ></p>
        <p
          className={
            current === 6
              ? 'h-5 rounded-full w-5 bg-[#040404] animate-bounce'
              : 'h-5 rounded-full w-5 bg-[#040404]'
          }
          onClick={(e) => setCurrent(6)}
        ></p>
      </div>
    </div>
  );
};

export default Spresso;
